import { ICONS, Icon, Loader, Table, Typography } from '@thinknet-gmbh/platform-common-ui';
import { Select } from 'antd';
import { useState } from 'react';
import { useGetProjectsByDate } from 'src/hooks/projects/get-projects-by-date.hook';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { useNavigate } from 'react-router-dom';
import { getDateRange } from 'src/pages/gantt/gantt.helpers';
import camelCase from 'lodash/camelCase';
import {
  HeaderContainer,
  SelectWrapper,
  TableContainer,
  TableHeaderContainer,
  TableHeaderLeftContainer,
  WidgetProjectsContainer,
} from './widgets.styles';
import { DateRangeEnums } from '../../projects-date-range.enums';
import { IDateRange } from '../../dasboard.interfaces';

const ProjectsWidgetContainer = ({ t }: { t: Function }) => {
  const [dateRangeName, setDateRangeName] = useState(DateRangeEnums.thisWeek.name);
  const [dateRange, setDateRange] = useState<any>(DateRangeEnums.thisWeek);

  const navigate = useNavigate();

  const { startDate, endDate } = getDateRange({
    type: dateRange.type,
    increment: dateRange.increment,
  });

  const { projects, loading, paginationConfig, setPage, onTableChange } = useGetProjectsByDate(
    startDate,
    endDate,
    dateRangeName
  );

  return (
    <WidgetProjectsContainer>
      <HeaderContainer>
        <TableHeaderContainer>
          <TableHeaderLeftContainer>
            <Icon icon={ICONS.projects} />
            <Typography weight="bold">{t('labels.projects')}</Typography>
          </TableHeaderLeftContainer>
          <SelectWrapper className="projects-time-selector">
            <Select
              defaultValue={dateRangeName}
              onChange={value => {
                setDateRangeName(value);
                setDateRange(
                  Object.values(DateRangeEnums).find((record: IDateRange) => record.name === value)
                );
              }}
            >
              {Object.values(DateRangeEnums).map(record => (
                <Select.Option key={record.name} value={record.name}>
                  {t(`selector.${camelCase(record.name)}`)}
                </Select.Option>
              ))}
            </Select>
          </SelectWrapper>
        </TableHeaderContainer>
      </HeaderContainer>
      <TableContainer id="projectsTableContainer">
        <InfiniteScroll
          dataLength={projects.length}
          next={() => setPage(prev => prev + 1)}
          hasMore={projects.length < paginationConfig.total}
          loader={<Loader />}
          scrollableTarget="projectsTableContainer"
        >
          <Table
            dataSource={projects}
            onChange={onTableChange}
            rowKey={record => record.projectId}
            loading={loading}
          >
            <Table.Column
              title={t('table.tabs.project.number')}
              dataIndex="projectNumber"
              render={projectNumber => <Typography>{projectNumber}</Typography>}
              sorter
              onCell={(record: any) => ({
                onClick: () => navigate(`${ROUTES.project}/${record.projectId}`),
              })}
            />
            <Table.Column
              title={t('table.tabs.project.name')}
              dataIndex="projectName"
              render={projectName => <Typography>{projectName}</Typography>}
              sorter
              onCell={(record: any) => ({
                onClick: () => navigate(`${ROUTES.project}/${record.projectId}`),
              })}
            />
            <Table.Column
              title={t('table.tabs.project.customer')}
              dataIndex="projectCustomer"
              render={projectCustomer => <Typography>{projectCustomer}</Typography>}
              sorter
              onCell={(record: any) => ({
                onClick: () => navigate(`${ROUTES.customers}/${record.projectCustomerId}`),
              })}
            />
            <Table.Column
              title={t('table.tabs.project.manager')}
              dataIndex="projectOwner"
              render={projectOwner => <Typography>{projectOwner}</Typography>}
              sorter
            />
            <Table.Column
              title={t('table.tabs.project.hours')}
              dataIndex="projectPlannedHours"
              render={projectPlannedHours => <Typography>{projectPlannedHours}</Typography>}
            />
          </Table>
        </InfiniteScroll>
      </TableContainer>
    </WidgetProjectsContainer>
  );
};

export default ProjectsWidgetContainer;
